import { ChangeDetectorRef, Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EMPTY, fromEvent, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, map, mergeMap, takeUntil, throttleTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { StoreState } from '../../core/states/store.state';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { GetCountries, GetPlans, GetStores, GetTemplates, StoreLoading, StoreNotLoading } from '../../core/states/store.actions';
import { DomainPatternValidator, EmailPatternValidator, StoreNamePatternValidator, SubDomainPatternValidator } from '../../core/constants/custom-validators.constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StoreService } from '../../store.service';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from 'src/app/core/utilities.service';

@Component({
  selector: 'app-domain-form',
  templateUrl: './domain-form.component.html',
  styleUrls: ['./domain-form.component.scss'],
})
export class DomainFormComponent implements OnInit, OnDestroy {
  @ViewChild('customDomainContent') customDomainLoader;
  @ViewChild('footerContent') footerContent;
  @ViewChild('templateContent') templateContent;

  defaultImg = 'https://via.placeholder.com/283x200.jpg/747e8b/ffffff?text=Template+image';
  paidSelected = false;

  freePlanCode = 'FIV5S_STARTER';
  maxFreeStore = 1;

  storeSubdomain = environment.storeSubdomain;

  state: any = {
    step: 3,
    emailRequired: false,
    customDomain: '',
    submitting: false,
    allowFreeStore: true
  };

  storeForm = this.fb.group({
    email: ['', [Validators.required, EmailPatternValidator]],
    useExistingDomain: [true, [Validators.required]],
    name: ['', [StoreNamePatternValidator, Validators.required, Validators.minLength(5)]],
    country: ['', [Validators.required, Validators.minLength(5)]],
    template: ['', [Validators.required]],
    plan: ['', [Validators.required]],
    useCustomDomain: true,
    subdomainName: ['', [Validators.required, SubDomainPatternValidator, Validators.minLength(3), Validators.maxLength(24)]],
    customDomain: ['', [DomainPatternValidator, Validators.minLength(5), Validators.maxLength(64)]],
  });

  maxCatDisplay = 12;
  viewAllCategories = false;
  isMobileView = false;

  templateFilters = [];
  selectedTemplateFilter;

  debouncedScrollEvent: Observable<any>;
  debouncedScrollSubscription: Subscription;
  throttledScrollEvent: Observable<any>;
  throttledScrollSubscription: Subscription;
  backToTopIsActive: boolean = false;
  backToTopIsAbsolute: boolean = false;
  validatingSubDomain: boolean = false;

  suggest = [];

  destroy$: Subject<boolean> = new Subject<boolean>();
  @Select(StoreState.countries) countries$: Observable<any[]>;
  @Select(StoreState.plans) plans$: Observable<any[]>;
  //@Select(StoreState.templates) templates$: Observable<any[]>;

  constructor(
    private store: Store,
    public router: Router,
    private fb: FormBuilder,
    private svc: StoreService,
    private modalService: NgbModal,
    private ngZone: NgZone,
    private utils: UtilitiesService,
    private cdr: ChangeDetectorRef
  ) {
    if (!window) {
      return;
    }

    ngZone.runOutsideAngular(() => {
      this.debouncedScrollEvent = fromEvent(window, 'scroll').pipe(
        debounceTime(100)
      );

      this.throttledScrollEvent = fromEvent(window, 'scroll').pipe(
        throttleTime(100)
      );

      this.throttledScrollSubscription = this.throttledScrollEvent.subscribe(
        (e) => {
          this.doScroll();
        }
      );

      this.debouncedScrollSubscription = this.debouncedScrollEvent.subscribe(
        (e) => {
          this.doScroll();
        }
      );
    });
  }

  ngOnInit(): void {
    const stores = this.store.selectSnapshot(StoreState.storesList);

    /*
    // Only allow 1 store
    if (stores.length) {
      this.router.navigate(['/dashboard']);
    }
    */

    this.state.allowFreeStore = (stores.filter((store) => store.store_plan === this.freePlanCode).length < this.maxFreeStore)

    this.store
      .dispatch([
        new StoreLoading(),
        //new GetTemplates(),
        new GetPlans(),
        new GetCountries(),
      ])
      .pipe(takeUntil(this.destroy$))
      .subscribe((_) => {
        const plans = this.store.selectSnapshot(StoreState.plans);
        const templates = this.store.selectSnapshot(StoreState.templates);
        const userInfo = this.store.selectSnapshot(StoreState.userInfo);
        const countries = this.store.selectSnapshot(StoreState.countries);

        console.log(userInfo);

        if (countries.length > 0) {
          this.country.patchValue(countries[5]);
        }

        if (plans.length > 0 && templates.length >= 0) {


          this.form.patchValue({
            plan: plans[+!this.state.allowFreeStore],
          });

          this.paidSelected = this.storePlan.value.id != 1;

          this.store.dispatch(new StoreNotLoading());
          if (userInfo && userInfo.profile && userInfo.profile.profile_email) {
            this.email.patchValue(userInfo.profile.profile_email);
            this.state.step = 1;
          }

          // const filters = ['All',...new Set([].concat.apply([], templates.map(item => item.tags)))];
          const filters = ['All', ...new Set(templates.map(item => item.category))];
          this.templateFilters = filters.map(item => ({ display: item, value: item }));

          // this.selectedTemplateFilter = this.templateFilters[0];
          this.updateTemplateDisplay(this.templateFilters[0]);
        }

      });

    this.useCustomDomain.valueChanges.subscribe((val) => {
      const { subdomainName, customDomain } = this.form.controls;
      customDomain.patchValue('');
      if (val) {
        // if(this.storePlan.value && this.storePlan.value.id == 1) {
        //   const plans = this.store.selectSnapshot(StoreState.plans);
        //   this.form.patchValue({
        //     plan:plans[1]
        //   });
        // }

        // subdomainName.markAsUntouched();
        customDomain.setValidators([
          Validators.required,
          DomainPatternValidator,
        ]);
      } else {
        customDomain.markAsUntouched();
        customDomain.clearValidators();
      }
      // subdomainName.updateValueAndValidity();
      customDomain.updateValueAndValidity();
    });

    this.checkWidth(null);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    // Unsubscribe from the subject
    this.destroy$.unsubscribe();
    // this.debouncedScrollEvent.unsubscribe();
    this.debouncedScrollSubscription.unsubscribe();
    // this.throttledScrollEvent.unsubscribe();
    this.throttledScrollSubscription && this.throttledScrollSubscription.unsubscribe();
  }

  ngOnChanges(): void { }

  @HostListener('window:resize', ['$event'])
  checkWidth(event) {
    const innerWidth = window.innerWidth;
    this.isMobileView = innerWidth < 1200;
  }

  gotoStep(num: number) {
    let isValid = true;

    if (this.state.step < num) {
      switch (this.state.step) {
        case 1:
          isValid = this.name.valid;
          break;
        case 2:
          isValid = this.canValidateDomain;
          break;
        case 3:
          isValid = this.storeTemplate.valid;
          break;
      }
    }

    if (isValid) {
      this.state.step = num;
      this.focusStepInput();
    }
  }

  nextStep(control?: AbstractControl) {
    if (control === undefined || (control && control.valid)) {

      if (this.state.step == 1) {
        this.state.step = (!this.useExistingDomain.value ? 2 : 3);
      }

      // this.state.step++;

      this.focusStepInput();
    } else {
      control.markAsTouched();
    }

    //console.log('Step changed', this.state.step)
    //if (this.state.step == 2) {
    // this.store.dispatch(new GetStores(null));
    // const { allowFreeStore } = this.state;
    // console.log({ allowFreeStore })      
    //}
  }

  prevStep() {
    if ([2, 3].includes(this.state.step)) {
      this.router.navigate(['/dashboard/domain']);
    }

    this.focusStepInput();
  }

  nextStepOnEnter(e: any) {
    console.log('current step', this.state.step)
    if (this.state.step == 2) {
      this.validateDomain();
      return;
    }
    if (this.state.step == 3) {
      console.log('asdasdasdas')
      this.validateExistingDomain();
      return;
    }
    this.submitEmail();
  }

  createCustomDomain() {

    const { customDomain } = this.form.controls;

    const store_id = localStorage.getItem('store_id');

    const params = {
      name: this.name.value,
      d_id: this.svc.userInfo.d_id,
      countryCode: this.country.value.country_code,
      planId: this.storePlan.value.id || 1,
      subDomain: this.subdomainName.value + '.' + this.storeSubdomain,
      useCustomDomain: this.useCustomDomain.value,
      customDomain: this.customDomain.value,
      templateId: this.storeTemplate.value.id || 1,
      storeId: store_id,
    };

    const token = localStorage.getItem('bearer');
    this.svc
      .createCustomDomain(token, params)
      .pipe(
        // mergeMap(
        map((res) => {
          if (res && res['status'] == 'success' && res['status_code'] == 200) {
            setTimeout(() => {
              const location = `${window.location.origin}${window.location.hash.indexOf('#') !== -1 ? '/#' : ''}`;
              window.location.href = `${location}/dashboard/domain`;//res.data.url;
              this.modalService.dismissAll();
            }, 0);
          }
        })
      )
      .subscribe(
        (_) => _,
        (_) => {
          this.modalService.dismissAll();
        }
      );
  }

  submitEmail() {
    const { email } = this.form.controls;

    console.log('submitting email...');
    if (email.valid) {
      this.modalService.open(this.customDomainLoader, {
        centered: true,
        backdrop: 'static',
      });

      const params = {
        email: email.value,
      };

      email.markAsTouched();
      this.svc.validateEmailAddress(params).subscribe(
        (res) => {
          if (res && res.code == 'OK') {
            this.modalService.dismissAll();

            if (res.status === true) {
              this.nextStep();
            } else {
              email.setErrors({ taken: true });
            }
          }
        },
        (err) => {
          console.log(err);
          email.setErrors({ taken: err });
          this.modalService.dismissAll();
        }
      );
    }
  }

  focusStepInput() {
    console.log(this.state.step)
    this.focusElement(`.main-input-${this.state.step}`);
  }

  focusElement(querySelector: string): void {
    setTimeout(
      () => (document.querySelector(querySelector) as any)?.focus(),
      1
    );
  }

  updatePlan(plan) {
    this.form.patchValue({ plan: plan });
  }

  updateTemplate(template) {
    this.form.patchValue({
      template: template.is_available == '1' ? template : '',
    });
  }

  validateDomain() {
    const { subdomainName, useCustomDomain, customDomain } = this.form.controls;

    if (false && subdomainName.value.trim() == '') {
      this.nextStep(subdomainName);
    } else {
      this.validatingSubDomain = false;
      this.modalService.open(this.customDomainLoader, {
        centered: true,
        backdrop: 'static',
      });
      const params1 = {
        domain: customDomain.value,
      };
      customDomain.markAsTouched();
      const token = localStorage.getItem('bearer');
      this.svc.validateDomain(token, params1).pipe(
        mergeMap(res => {
          if (res && res['status'] == 'success') {
            if (res['data'].available !== true) {

              this.suggestDomain();
            } else {

              this.createCustomDomain()

            }
          }

          this.modalService.dismissAll();
          //this.nextStep();
          return EMPTY;

        })
      ).subscribe(
        (res) => {
          /*
          if (res && res['status'] == 'success' && res['status_code'] == 200) {
            if (res['data'].available == true) {
              if (subdomainName.valid) {
                //this.nextStep();
              }
            } else {
              customDomain.setErrors({ taken: true });
              this.nextStep(customDomain);
            }

            setTimeout(() => {
              this.modalService.dismissAll();
            }, 200);
          }*/
        },
        (err) => {
          const res = err.error;
          if (res && res['status'] == 'error' && res['status_code'] == 400 && res['message'].domain === 'The domain field must contain a unique value.') {
            this.suggestDomain();
          } else {
            customDomain.setErrors({ pattern: true });
          }
          this.modalService.dismissAll();
        }
      );
    }
  }

  validateExistingDomain() {
    const { customDomain } = this.form.controls;

    this.validatingSubDomain = false;
    this.modalService.open(this.customDomainLoader, {
      centered: true,
      backdrop: 'static',
    });
    const params1 = {
      domain: customDomain.value,
    };
    customDomain.markAsTouched();

    const token = localStorage.getItem('bearer');
    this.svc.validateDomain(token, params1).pipe(
      mergeMap(res => {
        if (res && res['status'] == 'success') {
          console.log('res', { res })
          if (res['data'].available !== true) {
            this.postExistingDomain()
          } else {            
            const errorMsg = "Domain is not yet registered. Make sure the domain is registered to be used as the existing domain.";
            this.utils.notify.showError(errorMsg);
            customDomain.setErrors({ server_error: errorMsg });
            this.modalService.dismissAll();
          }
        }
        //this.nextStep();
        return EMPTY;

      })
    ).subscribe(
      (res) => { },
      (err) => {
        const res = err.error;
        if (res && res['status'] == 'error' && res['status_code'] == 400 && res['message'].domain === 'The domain field must contain a unique value.') {
        } else {
          customDomain.setErrors({ pattern: true });
        }
        this.modalService.dismissAll();
      }
    );

  }


  postExistingDomain() {
    const { customDomain } = this.form.controls;

    const store_id = localStorage.getItem('store_id');

    const params = {
      name: this.name.value,
      d_id: this.svc.userInfo.d_id,
      countryCode: this.country.value.country_code,
      planId: this.storePlan.value.id || 1,
      subDomain: this.subdomainName.value + '.' + this.storeSubdomain,
      useCustomDomain: this.useCustomDomain.value,
      customDomain: this.customDomain.value,
      templateId: this.storeTemplate.value.id || 1,
      storeId: store_id,
    };

    const token = localStorage.getItem('bearer');
    this.svc
      .createExistingCustomDomain(token, params)
      .subscribe(
        (res) => {
          this.utils.notify.showSuccess("Domain created successfully");
          this.modalService.dismissAll();
          if (res && res['status'] == 'success' && res['status_code'] == 200) {
            this.router.navigate(['/dashboard/domain'])
          }
        },
        (_failed) => {
          this.utils.notify.showError(_failed.error.message);
          if (_failed.ok === false) {
            console.log('ERROR: ', _failed.error.message)
            customDomain.setErrors({ server_error: _failed.error.message });
            this.modalService.dismissAll();
          }
        }
      );
  }

  suggestDomain() {
    const { customDomain } = this.form.controls;
    const token = localStorage.getItem('bearer');
    const params1 = {
      domain: customDomain.value,
    };
    this.svc.suggestDomain(token, params1).pipe(
      mergeMap(res => {
        if (res && res['status'] == 'success' && res['status_code'] == 'OK') {
          const index = res['data'].indexOf(customDomain.value);
          if (index > -1) {
            res['data'].splice(index, 1); // 2nd parameter means remove one item only
          }
          this.suggest = res['data'] ? (res['data']) : '';
          customDomain.setErrors({ taken: true, suggest: this.suggest });
          customDomain.markAsTouched();

          console.log("suggestdomain==", this.suggest)
        }
        return EMPTY;
      })
    ).subscribe(
      (res) => { },
      (err) => { }
    );
  }

  selectbtn(s) {
    const { subdomainName, customDomain } = this.form.controls;
    customDomain.patchValue(s);
  }

  validateTemplate() {
    this.nextStep();
  }

  loadAllCategories() {
    this.maxCatDisplay += 10;

    if (this.maxCatDisplay >= this.filteredTemplates.length) {
      this.viewAllCategories = false;
    }
  }

  getStyle(img) {
    return `background-image: url('/assets/thumbnail/${img}')`;
  }

  getList(desc) {
    return (desc && desc.replace(/[\"{}]/g, '').split('|')) || [];
  }

  updateTemplateDisplay(filter) {
    // this.maxCatDisplay = 4;
    this.selectedTemplateFilter = filter;
    this.viewAllCategories = this.maxCatDisplay < this.filteredTemplates.length;

    this.storeTemplate.patchValue('');
  }

  get canValidateDomain() {
    const subDom = this.subdomainName.valid || this.subdomainName.disabled;
    if (this.useCustomDomain.value && this.customDomain.value) {
      return this.customDomain.valid;
      //return subDom && this.customDomain.valid;
    }

    return subDom;
  }

  scrollToTop(el) {
    el.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  private getPageOffsetTopOf(element) {
    let currentElement = element;
    let top = currentElement.offsetTop;

    while (currentElement.offsetParent) {
      currentElement = currentElement.offsetParent;
      top += currentElement.offsetTop;
    }

    return top;
  }

  getWindowScrollY() {
    return typeof window.scrollY === 'number'
      ? window.scrollY
      : document.documentElement.scrollTop;
  }

  openTemplate(template, state) {
    if (this.isMobileView) {
      if (state.canOpen) {
        window.open(template.store_preview_link || '#', '_blank');
      }
      state.canOpen = true;
    } else {
      window.open(template.store_preview_link || '#', '_blank');
    }
  }

  private doScroll() {
    if (this.footerContent) {
      let scrollY = this.getWindowScrollY();
      let showBackToTopThreshold = window.innerHeight;
      let windowBottom = scrollY + window.innerHeight;
      let absoluteThreshold = this.getPageOffsetTopOf(
        this.footerContent.nativeElement
      );

      this.backToTopIsActive = scrollY >= showBackToTopThreshold;
      this.backToTopIsAbsolute = absoluteThreshold <= windowBottom;
    }

    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  get storeUrl() {
    return this.customDomain.value;
  }

  get form() {
    return this.storeForm;
  }

  get useExistingDomain() {
    return this.form.get('useExistingDomain');
  }

  get storeTemplate() {
    return this.form.get('template');
  }

  get storePlan() {
    return this.form.get('plan');
  }

  get email() {
    return this.form.get('email');
  }

  get name() {
    return this.form.get('name');
  }

  get country() {
    return this.form.get('country');
  }

  get useCustomDomain() {
    return this.form.get('useCustomDomain');
  }

  get subdomainName() {
    return this.form.get('subdomainName');
  }

  get customDomain() {
    return this.form.get('customDomain');
  }

  get filteredTemplates() {
    let filtered = [];
    const templates = this.store.selectSnapshot(StoreState.templates);
    if (templates.length) {
      filtered = templates.filter(
        (item) => item['store_price'] == (this.paidSelected ? 'paid' : 'free')
      );
    }

    const filter = this.selectedTemplateFilter.value;
    // console.log(filtered)
    if (filter != 'All') {
      filtered = filtered.filter(item => item.category == filter);
    }

    // this.viewAllCategories = this.maxCatDisplay < filtered.length;

    return filtered;
  }

  get filteredPlans() {
    const plans = this.store.selectSnapshot(StoreState.plans);
    if (plans.length) {
      if (this.paidSelected) {
        return plans.filter((item) => item['plan_price'] != 0);
      }
      return plans;
    }

    return [];
  }
}